import { num, type ComponentForm } from '../component-types.js';

/**
 * `dynamics`: cloth / hair / bone-chain physics on any model (capes, skirts,
 * flags, curtains, hair cards, manes, tails, ears, ponytails, ropes)
 * (see engine/docs/systems/dynamics.md).
 */
const form: ComponentForm = {
  key: 'dynamics',
  label: 'Dynamics (cloth, hair, chains)',
  icon: 'data',
  order: 48,
  defaults: { cloth: [{ target: 'cape', pin: 'top', pinBand: 0.06, bend: 0.3 }] },
  fields: [
    {
      key: 'cloth',
      label: 'Cloth / hair',
      type: { kind: 'json' },
      hint: '[{ "target": "cape" (part or material name), "pin": "top" | "root" (hair cards) | "spheres" | "none", "pinBand": 0.06, "pinSpheres": [{ "center": [x,y,z], "radius": r }], "stiffness": 0.95, "bend": 0.3 (0 silk .. 1 leather), "damping": 0.04, "gravity": 1, "wind": 1, "shapeMemory": 0 (keeps hairstyles / flared skirts), "iterations": 6, "thickness": 0.01 }]',
    },
    {
      key: 'chains',
      label: 'Bone chains',
      type: { kind: 'json' },
      hint: '[{ "root": "tail1", "stiffness": 0.1, "damping": 0.1, "gravity": 1, "wind": 1, "radius": 0.02, "angleLimit": 0 }] — tails, ears, ponytails, antennae.',
    },
    {
      key: 'colliders',
      label: 'Extra colliders',
      type: { kind: 'json' },
      hint: '[{ "bone": "chest" (optional), "center": [x,y,z], "end": [x,y,z] (capsule), "radius": 0.2 }]',
    },
    { key: 'autoColliders', label: 'Body colliders from skeleton', type: { kind: 'bool' }, read: (v) => v.autoColliders ?? true },
    { key: 'ground', label: 'Collide with ground', type: { kind: 'bool' }, read: (v) => v.ground ?? true },
    { key: 'wind', label: 'Wind ×', type: num(0.1, { min: 0 }), read: (v) => v.wind ?? 1 },
    { key: 'rate', label: 'Steps / second', type: num(10, { min: 20, max: 480 }), read: (v) => v.rate ?? 90 },
    { key: 'simulateInEditor', label: 'Simulate in editor', type: { kind: 'bool' }, read: (v) => v.simulateInEditor ?? false },
  ],
};
export default form;
